export default "__VITE_PUBLIC_ASSET__a145acee__"